import React, { useEffect, useState } from 'react';
import useCheckPermission from '../../../utils/permissions/useCheckPermissions';
import DepartmentDataService from '../../../services/DepartmentService';
import LocationDataService from '../../../services/LocationService';
import AdminDataService from '../../../services/Admins';
import AdminLocationsDataService from '../../../services/AdminLocations';
import AdminLocations from '../../../services/AdminLocations';
import { Snackbar } from '@mui/material';
import Alert from '@material-ui/lab/Alert';
import { useTranslation } from 'react-i18next';
// import EditModalForm from './EditFiles/EditModal'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { InputAdornment, Slider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AdministratorsRolesService from '../../../services/AdministratorsRolesService';
import zxcvbn from 'zxcvbn';
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import CreateIcon from '@mui/icons-material/Create';
import axios from 'axios';
import { API_URL } from '../../../utils/setApiUrl.js';
import Chip from '@material-ui/core/Chip';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import Tooltip from '@mui/material/Tooltip';
import translateRole from '../../../utils/roleTranslations';

const useStyles = makeStyles(theme => ({
    root: props => ({
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        '& .MuiTextField-root': {
            margin: theme.spacing(0.5),
            marginTop: 0,
            width: '98%',
        },
        '& .MuiBox-root': {
            padding: '0 !important',
        },
        '& .MuiButton-root': {
            margin: theme.spacing(1),
        },
        '& .MuiAlert-root': {
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(1),
            },
        },
    }),
    passwordList: {
        '& .MuiListSubheader-gutters': {
            paddingLeft: '0px !important',
        },
    },
}));
const SystemUsers = () => {
    const { t } = useTranslation();
    const isSuper = useCheckPermission('super');
    const level = localStorage.getItem('level');
    const canManageAdmins = isSuper || level === 'admin';

    const classes = useStyles();

    const [adminRoles, setAdminRoles] = useState([]);
    const [users, setUser] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [usersPin, setUserPin] = useState([]);

    useEffect(() => {
        retrieveSystemUsers();
        // retrieveDepartments();
        retrieveLocations();
        retrieveAdminRoles();
    }, []);

    const client = axios.create({
        baseURL: API_URL,
    });

    const [loc] = React.useState(() => {
        const locData = localStorage.getItem('loc');
        return locData ? JSON.parse(locData).id : '';
    });

    const retrieveSystemUsers = () => {
        AdminDataService.getAll()
            .then(response => {
                setUser(response.data);
            })
            .catch(e => {
                setErrorMessages(['Cannot load user data']);
                setIserror(true);
            });
    };

    //for error handling
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // * Retrieve Locations & Departments
    const [departmentsOptions, setDepartmentsOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);

    const retrieveLocations = () => {
        LocationDataService.getAll()
            .then(response => {
                setLocationOptions(response.data);
            })
            .catch(e => {
                setErrorMessages(['Cannot load user data']);
                setIserror(true);
            });
    };

    const retrieveAdminRoles = () => {
        AdministratorsRolesService.getAll()
            .then(response => {
                setAdminRoles(response.data);
            })
            .catch(e => {
                setErrorMessages(['Cannot load user data']);
                setIserror(true);
            });
    };

    const retrieveDepartments = () => {
        if (JSON.parse(localStorage.getItem('loc')).id >= 0) {
            DepartmentDataService.getAll(loc)
                .then(response => {
                    return response.data.reduce((acc, item) => {
                        acc[item.name] = item.name;
                        setDepartmentsOptions(acc);
                        return acc;
                    }, {});
                })
                .catch(e => {
                    setErrorMessages(['Cannot load user data']);
                    setIserror(true);
                });
        } else if (JSON.parse(localStorage.getItem('loc')).id === 'all') {
            DepartmentDataService.adminAll()
                .then(response => {
                    return response.data.reduce((acc, item) => {
                        acc[item.name] = item.name;
                        setDepartmentsOptions(acc);
                        return acc;
                    }, {});
                })
                .catch(e => {
                    setErrorMessages(['Cannot load user data']);
                    setIserror(true);
                });
        }
    };
    // * End of retrieving Locations & Departments

    // * Create new System User START
    const initialUserState = {
        id: '',
        name: '',
        nikname: '',
        active: true,
        email: '',
        role: '',
        phone: '',
        password: '',
        location: [],
    };
    const [newSystemUser, setNewSystemUser] = useState(initialUserState);

    // ! password strength START
    const [passwordStrength, setPasswordStrength] = useState(null);

    const getPasswordStrengthColor = score => {
        switch (score) {
            case 0:
                return '#f44336'; // red
            case 1:
                return '#ff9800'; // orange
            case 2:
                return '#4caf50'; // light green
            case 3:
                return '#388e3c'; // green
            default:
                return '#388e3c'; // red
        }
    };

    const marks = [{ value: 0 }, { value: 1 }, { value: 2 }, { value: 3 }];

    // ! password strength END

    const handleInputChange = event => {
        const { name, value } = event.target;

        // Update to handle phone input specifically
        if (name === 'phone') {
            // Remove spaces from the phone input
            const formattedValue = value.replace(/\s+/g, '');
            setNewSystemUser({ ...newSystemUser, [name]: formattedValue });
        } else {
            // Handle other inputs normally
            setNewSystemUser({ ...newSystemUser, [name]: value });
        }

        // Example additional logic for password field
        if (name === 'password') {
            setPasswordStrength(zxcvbn(value));
        }
    };

    // ! Snackbars Start
    const [snackbars, setSnackbars] = useState([]);

    const handleCloseSnackbar = id => {
        setSnackbars(prevSnackbars =>
            prevSnackbars.filter(snackbar => snackbar.id !== id)
        );
    };

    const handleShowSnackbar = (message, severity) => {
        const id = new Date().getTime(); // Unique ID for each snackbar
        const newSnackbar = {
            id,
            message,
            severity,
            position: snackbars.length * 55,
        };

        setSnackbars(prevSnackbars => [...prevSnackbars, newSnackbar]);
    };
    // ! Snackbars End

    const saveSystemUser = () => {
        handleShowSnackbar(
            t('systemAdmin.systemUsers.creatingAccount'),
            'info'
        );

        var userData = {
            id: newSystemUser.id,
            name: newSystemUser.name,
            nikname: newSystemUser.nikname,
            active: newSystemUser.active,
            email: newSystemUser.email,
            role: newSystemUser.role,
            phone: `+359${newSystemUser.phone}`,
            password: newSystemUser.password,
            location: [], // This seems to be not used since locations are handled separately
        };

        AdminDataService.create(userData)
            .then(async response => {
                const userId = response.data.id; // The newly created user's ID

                // Assuming newSystemUser.location is an array of location objects
                // Prepare the location data for each selected location
                const locationPromises = newSystemUser.location.map(
                    location => {
                        var locationData = {
                            admin_id: userId,
                            location_id: location.id, // Assuming each location object has an id property
                        };
                        return AdminLocationsDataService.create(locationData);
                    }
                );

                // Execute all location association requests in parallel
                try {
                    await Promise.all(locationPromises);
                    handleShowSnackbar(
                        t('systemAdmin.systemUsers.locationAssigned'),
                        'success'
                    );
                } catch (error) {
                    handleShowSnackbar(
                        t('systemAdmin.systemUsers.locationAssignError'),
                        'error'
                    );
                    console.error(error);
                }

                // Additional logic for after successful user and locations creation
                retrieveSystemUsers();
                setNewSystemUser(initialUserState);
                setPasswordStrength(null);
                handleShowSnackbar(
                    t('systemAdmin.systemUsers.accountCreated'),
                    'success'
                );
            })
            .catch(e => {
                const errorCode =
                    e &&
                    e.response &&
                    e.response.data &&
                    e.response.data.code;
                if (errorCode === 'NIKNAME_EXISTS') {
                    handleShowSnackbar(
                        t('systemAdmin.systemUsers.usernameExists'),
                        'error'
                    );
                } else if (errorCode === 'NIKNAME_DELETED') {
                    handleShowSnackbar(
                        t('systemAdmin.systemUsers.usernameDeleted'),
                        'error'
                    );
                } else {
                    handleShowSnackbar(
                        t('systemAdmin.systemUsers.accountError'),
                        'error'
                    );
                }
                console.error(e);
            });
    };
    // * Create new System User END

    // * Update System User Start
    async function updateSystemUser(e, link) {
        try {
            if (link.active === true) {
                const response = await AdminDataService.updateRole(
                    e.target.id,
                    {
                        active: false,
                    }
                );
                console.log(response);
                retrieveSystemUsers(); // Rebuild System Users from the retrieveSystemUsers function
            } else {
                const response = await AdminDataService.updateRole(
                    e.target.id,
                    {
                        active: true,
                    }
                );
                console.log(response);
                retrieveSystemUsers(); // Rebuild System Users from the retrieveSystemUsers function
            }
        } catch (error) {
            console.log(error);
        }
    }

    // * Update System User End

    // * Edit System User Start
    const [edit, setEdit] = useState(false);
    const [editId, setEditId] = useState(null); // provide a default value

    async function getSystemUser(link) {
        setEdit(true);

        try {
            const response = await AdminDataService.get(link.id);
            const userData = response.data;

            // Map user's locations to the format expected by the Autocomplete component
            console.log('User Data:', userData); // Debugging

            const userLocations = userData.AdminLocation.map(loc => {
                return locationOptions.find(
                    option => option.id === loc.location_id
                );
            }).filter(loc => loc); // Remove any undefined or null

            console.log('Mapped Locations:', userLocations); // Debugging

            setNewSystemUser({
                id: userData.id,
                name: userData.name,
                nikname: userData.nikname,
                active: userData.active,
                email: userData.email,
                role: userData.AdminRole.id, // Use the role ID
                phone: userData.phone.startsWith('+359')
                    ? userData.phone.substring(4)
                    : userData.phone,
                password: '', // Assuming password is not retrieved for security reasons
                location: userLocations, // Array of matched location objects
            });
            setEditId(userData.id);
        } catch (error) {
            console.log(error);
        }
    }

    async function editSystemUser(e, link) {
        try {
            // Retrieve current user data, including current locations
            const currentUserResponse = await AdminDataService.get(editId);
            const currentUserData = currentUserResponse.data;
            const currentLocationIds = new Set(
                currentUserData.AdminLocation.map(loc => loc.location_id)
            );

            const response = await AdminDataService.update(editId, {
                id: newSystemUser.id,
                name: newSystemUser.name,
                nikname: newSystemUser.nikname,
                active: newSystemUser.active,
                email: newSystemUser.email,
                role: newSystemUser.role,
                phone: `+359${newSystemUser.phone}`,
                password: newSystemUser.password,
                location: newSystemUser.location.map(loc => loc.id),
            });

            if (response.status === 200) {
                // Determine the updated locations
                const updatedLocationIds = new Set(
                    newSystemUser.location.map(loc => loc.id)
                );

                // Delete locations that were removed
                const locationsToDelete = [...currentLocationIds].filter(
                    id => !updatedLocationIds.has(id)
                );
                for (const locId of locationsToDelete) {
                    await client.delete(
                        `/v1/adminLocations/${editId}/${locId}`
                    );
                }

                // Create new locations
                for (const location of newSystemUser.location) {
                    if (!currentLocationIds.has(location.id)) {
                        await AdminLocations.create({
                            admin_id: editId,
                            location_id: location.id,
                        });
                    }
                }

                handleShowSnackbar(
                    `Успешно редактирахте администратора!`,
                    'success'
                );
            }
        } catch (error) {
            console.log(error);
        }
    }

    // * Edit System User End

    // * Remove System User Start
    async function removeSystemUser(e, link) {
        const confirmed = window.confirm(
            t('systemAdmin.systemUsers.confirmDelete', {
                username: link.nikname,
            })
        );
        if (!confirmed) {
            return;
        }

        try {
            const response = await AdminDataService.remove(e.currentTarget.id);
            console.log(response);
            handleShowSnackbar(
                t('systemAdmin.systemUsers.userDeleted'),
                'success'
            );
            retrieveSystemUsers();
        } catch (error) {
            handleShowSnackbar(
                t('systemAdmin.systemUsers.accountError'),
                'error'
            );
            console.log(error);
        }
    }

    async function restoreSystemUser(link) {
        try {
            const response = await AdminDataService.restore(link.id);
            console.log(response);
            handleShowSnackbar(
                t('systemAdmin.systemUsers.userRestored'),
                'success'
            );
            retrieveSystemUsers();
        } catch (error) {
            handleShowSnackbar(
                t('systemAdmin.systemUsers.restoreError'),
                'error'
            );
            console.log(error);
        }
    }

    const activeUsers = users.filter(user => !user.deletedAt);
    const deletedUsers = users.filter(user => user.deletedAt);

    const renderSystemUserRow = (link, isDeleted) => {
        const crossedOutStyle = isDeleted
            ? {
                  textDecoration: 'line-through',
                  opacity: 0.65,
              }
            : {};

        return (
            <ListItem key={`${link.id}-${isDeleted ? 'deleted' : 'active'}`} id={link.id}>
                <ListItemText
                    primary={link.nikname}
                    secondary={translateRole(link.AdminRole.role_name, t)}
                    style={crossedOutStyle}
                />
                <ListItemSecondaryAction
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                    }}
                >
                    {!isDeleted && (
                        <Switch
                            id={link.id}
                            name={'Включено'}
                            checked={Boolean(link.active)}
                            value={link.active}
                            onClick={e => updateSystemUser(e, link)}
                        />
                    )}
                    {canManageAdmins && !isDeleted && (
                        <>
                            <div
                                style={{
                                    width: '1px',
                                    height: '24px',
                                    backgroundColor: '#ccc',
                                    margin: '0 4px',
                                }}
                            />
                            <Tooltip
                                title={t('systemAdmin.systemUsers.editUser')}
                                placement="top"
                            >
                                <Button
                                    id={link.id}
                                    className={classes.adminButton}
                                    aria-controls="menu-admin"
                                    style={{
                                        minWidth: '40px',
                                        padding: 0,
                                        margin: 0,
                                    }}
                                    onClick={() => {
                                        setEditId(link.id);
                                        getSystemUser(link);
                                    }}
                                >
                                    <CreateIcon />
                                </Button>
                            </Tooltip>
                        </>
                    )}
                    {canManageAdmins && !isDeleted && (
                        <>
                            <div
                                style={{
                                    width: '1px',
                                    height: '24px',
                                    backgroundColor: '#ccc',
                                    margin: '0 4px',
                                }}
                            />
                            <Tooltip
                                title={t('systemAdmin.systemUsers.deleteUser')}
                                placement="top"
                            >
                                <Button
                                    id={link.id}
                                    className={classes.adminButton}
                                    aria-controls="menu-admin"
                                    style={{
                                        minWidth: '40px',
                                        padding: 0,
                                        margin: 0,
                                    }}
                                    onClick={e => removeSystemUser(e, link)}
                                >
                                    <DeleteIcon />
                                </Button>
                            </Tooltip>
                        </>
                    )}
                    {canManageAdmins && isDeleted && (
                        <Tooltip
                            title={t('systemAdmin.systemUsers.restoreUser')}
                            placement="top"
                        >
                            <Button
                                id={link.id}
                                className={classes.adminButton}
                                aria-controls="menu-admin"
                                style={{
                                    minWidth: '40px',
                                    padding: 0,
                                    margin: 0,
                                }}
                                onClick={() => restoreSystemUser(link)}
                            >
                                <RestoreFromTrashIcon />
                            </Button>
                        </Tooltip>
                    )}
                </ListItemSecondaryAction>
            </ListItem>
        );
    };

    // * Remove System User End

    // * Admin Locations Logic
    // Assuming you have a state for the selected options
    const [selectedOptions, setSelectedOptions] = React.useState([]);

    // Custom delete action
    const handleDelete = optionToDelete => async () => {
        try {
            const response = await AdminLocationsDataService.remove(
                editId,
                optionToDelete.id
            );
            if (response.status === 200) {
                handleShowSnackbar(
                    t('systemAdmin.systemUsers.locationRemoved', {
                        location: optionToDelete.id,
                        name: newSystemUser.name,
                    }),
                    'success'
                );
                setNewSystemUser(prevState => ({
                    ...prevState,
                    location: prevState.location.filter(
                        loc => loc.id !== optionToDelete.id
                    ),
                }));
            }
        } catch (e) {
            console.error('Error removing location:', e);
            setErrorMessages(['Cannot load user data']);
            setIserror(true);
        }
    };

    const handleCreate = async selectedOption => {
        try {
            const response = await AdminLocationsDataService.create({
                admin_id: editId,
                location_id: selectedOption.number,
            });
            if (response.status === 200) {
                handleShowSnackbar(
                    t('systemAdmin.systemUsers.locationAdded', {
                        location: selectedOption.number,
                        name: newSystemUser.name,
                    }),
                    'success'
                );
                setNewSystemUser(prevState => {
                    // Check if the selectedOption is already included to prevent duplicates
                    const isAlreadyIncluded = prevState.location.some(
                        location => location.id === selectedOption.id
                    );
                    if (!isAlreadyIncluded) {
                        return {
                            ...prevState,
                            location: [...prevState.location, selectedOption],
                        };
                    } else {
                        return prevState; // Return the existing state if the option is already included
                    }
                });
            }
        } catch (e) {
            console.error('Error adding location:', e);
            setErrorMessages(['Cannot load user data']);
            setIserror(true);
        }
    };

    // * Different Clients
    const currentHost = window.location.hostname;
    const isBilla = currentHost === 'billa.biodit.bg';

    // Add this function after the other state declarations
    const generatePassword = () => {
        const length = 8;
        const charset = {
            uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            lowercase: 'abcdefghijklmnopqrstuvwxyz',
            numbers: '0123456789',
            symbols: '!@#$%^&*()_+-=[]{}|;:,.<>?',
        };

        // Ensure at least one character from each set
        let password = '';
        password += charset.uppercase.charAt(
            Math.floor(Math.random() * charset.uppercase.length)
        );
        password += charset.lowercase.charAt(
            Math.floor(Math.random() * charset.lowercase.length)
        );
        password += charset.numbers.charAt(
            Math.floor(Math.random() * charset.numbers.length)
        );
        password += charset.symbols.charAt(
            Math.floor(Math.random() * charset.symbols.length)
        );

        // Fill the rest randomly
        const allChars = Object.values(charset).join('');
        for (let i = password.length; i < length; i++) {
            password += allChars.charAt(
                Math.floor(Math.random() * allChars.length)
            );
        }

        // Shuffle the password
        password = password
            .split('')
            .sort(() => Math.random() - 0.5)
            .join('');

        // Update the state and trigger password strength check
        setNewSystemUser(prev => ({ ...prev, password }));
        setPasswordStrength(zxcvbn(password));
    };

    // Add this state near your other state declarations
    const [showPassword, setShowPassword] = useState(false);

    // Add this handler function near your other handlers
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div>
            {snackbars
                .slice()
                .reverse()
                .map((snackbar, index) => (
                    <Snackbar
                        key={snackbar.id}
                        open={true}
                        autoHideDuration={10000}
                        onClose={() => handleCloseSnackbar(snackbar.id)}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        style={{ bottom: `${10 + index * 55}px` }}
                    >
                        <Alert
                            elevation={6}
                            variant="filled"
                            severity={snackbar.severity}
                            onClose={() => handleCloseSnackbar(snackbar.id)}
                        >
                            {snackbar.message}
                        </Alert>
                    </Snackbar>
                ))}
            <main className={classes.content} style={{ padding: 0, margin: 0 }}>
                <Grid container spacing={0} style={{ padding: 0, margin: 0 }}>
                    <Grid
                        item
                        xs={12}
                        lg={6}
                        style={{ height: '74vh' }}
                        alignItems="center"
                    >
                        <Paper
                            elevation={0}
                            square
                            style={{
                                borderRight: '1px solid #ccc',
                                height: '100%',
                                padding: '0',
                                overflowY: 'scroll',
                            }}
                        >
                            <List
                                className={classes.root}
                                lg={{
                                    width: '100%',
                                    maxWidth: 360,
                                    bgcolor: 'background.paper',
                                    position: 'relative',
                                    overflow: 'scroll',
                                    maxHeight: '200px',
                                    '& ul': { padding: 0 },
                                }}
                                subheader={
                                    <ListSubheader>
                                        {t(
                                            'systemAdmin.systemUsers.usersTitle'
                                        )}
                                    </ListSubheader>
                                }
                            >
                                {activeUsers.map(link => renderSystemUserRow(link, false))}
                                {deletedUsers.length > 0 && (
                                    <ListSubheader>
                                        {t(
                                            'systemAdmin.systemUsers.deletedUsersTitle'
                                        )}
                                    </ListSubheader>
                                )}
                                {deletedUsers.map(link =>
                                    renderSystemUserRow(link, true)
                                )}
                            </List>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} lg={6}>
                        <Paper
                            square
                            elevation={0}
                            style={{
                                padding: '2%',
                                paddingTop: '0',
                            }}
                        >
                            <List
                                subheader={
                                    <ListSubheader>
                                        {t(
                                            'systemAdmin.systemUsers.addUserTitle'
                                        )}
                                    </ListSubheader>
                                }
                                className={classes.root}
                            >
                                <form className={classes.root}>
                                    <TextField
                                        required
                                        id="outlined-required name"
                                        label={t(
                                            'systemAdmin.systemUsers.name'
                                        )}
                                        name="name"
                                        style={{ marginTop: 0 }}
                                        value={newSystemUser.name || ''}
                                        onChange={handleInputChange}
                                        size="small"
                                        variant="standard"
                                    />
                                    <TextField
                                        required
                                        id="outlined-required nikname"
                                        label={t(
                                            'systemAdmin.systemUsers.username'
                                        )}
                                        name="nikname"
                                        value={newSystemUser.nikname || ''}
                                        onChange={handleInputChange}
                                        size="small"
                                        variant="standard"
                                    />
                                    <TextField
                                        id="outlined-required email"
                                        label={t(
                                            'systemAdmin.systemUsers.email'
                                        )}
                                        name="email"
                                        value={newSystemUser.email || ''}
                                        onChange={handleInputChange}
                                        size="small"
                                        variant="standard"
                                    />
                                    <TextField
                                        {...(isBilla ? { required: true } : {})}
                                        id="outlined-required phone"
                                        label={t(
                                            'systemAdmin.systemUsers.phone'
                                        )}
                                        name="phone"
                                        value={newSystemUser.phone || ''}
                                        onChange={handleInputChange}
                                        size="small"
                                        variant="standard"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    +359
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <TextField
                                        id="role"
                                        select
                                        label={t(
                                            'systemAdmin.systemUsers.roleType'
                                        )}
                                        name="role"
                                        required
                                        value={newSystemUser.role || ''}
                                        onChange={handleInputChange}
                                        size="small"
                                        variant="standard"
                                    >
                                        {adminRoles.map(adminRole => (
                                            <MenuItem
                                                key={adminRole.id}
                                                value={adminRole.id}
                                            >
                                                {translateRole(
                                                    adminRole.role_name,
                                                    t
                                                )}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    {(() => {
                                        if (edit) {
                                            return (
                                                <Autocomplete
                                                    multiple
                                                    value={
                                                        newSystemUser.location ||
                                                        []
                                                    }
                                                    onChange={(
                                                        event,
                                                        newValue,
                                                        reason
                                                    ) => {
                                                        // Handle the selection differently based on the reason
                                                        if (
                                                            reason ===
                                                            'select-option'
                                                        ) {
                                                            const selectedOption =
                                                                newValue[
                                                                    newValue.length -
                                                                        1
                                                                ];
                                                            // Await handleCreate or ensure it updates the state correctly
                                                            handleCreate(
                                                                selectedOption,
                                                                () => {
                                                                    // Callback to update state, if necessary
                                                                }
                                                            );
                                                        } else if (
                                                            reason ===
                                                            'remove-option'
                                                        ) {
                                                            // Handle option removal here
                                                            // Note: You'll need the specific option that was removed if you want to use handleDelete
                                                        }

                                                        // Update the newSystemUser state with the new location array regardless of the action
                                                        setNewSystemUser(
                                                            prevState => ({
                                                                ...prevState,
                                                                location: newValue,
                                                            })
                                                        );
                                                    }}
                                                    id="location"
                                                    getOptionLabel={location =>
                                                        location.name.toString()
                                                    }
                                                    getOptionSelected={(
                                                        option,
                                                        value
                                                    ) => option.id === value.id}
                                                    options={locationOptions}
                                                    size="small"
                                                    renderTags={(
                                                        value,
                                                        getTagProps
                                                    ) =>
                                                        value.map(
                                                            (option, index) => (
                                                                // Customize Chip here
                                                                <Chip
                                                                    label={
                                                                        option.name
                                                                    } // Adjust based on your data structure
                                                                    // We're not spreading getTagProps directly
                                                                    {...getTagProps(
                                                                        {
                                                                            index,
                                                                        }
                                                                    )}
                                                                />
                                                            )
                                                        )
                                                    }
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            label={t(
                                                                'systemAdmin.systemUsers.location'
                                                            )}
                                                            required
                                                            variant="standard"
                                                        />
                                                    )}
                                                />
                                            );
                                        }
                                        return (
                                            <Autocomplete
                                                multiple
                                                value={
                                                    newSystemUser.location || []
                                                }
                                                onChange={(
                                                    event,
                                                    newValue,
                                                    reason
                                                ) => {
                                                    // Update the newSystemUser state with the new location array regardless of the action
                                                    setNewSystemUser(
                                                        prevState => ({
                                                            ...prevState,
                                                            location: newValue,
                                                        })
                                                    );
                                                }}
                                                id="location"
                                                getOptionLabel={location =>
                                                    location.name.toString()
                                                }
                                                getOptionSelected={(
                                                    option,
                                                    value
                                                ) => option.id === value.id}
                                                options={locationOptions}
                                                size="small"
                                                renderTags={(
                                                    value,
                                                    getTagProps
                                                ) =>
                                                    value.map(
                                                        (option, index) => (
                                                            // Customize Chip here
                                                            <Chip
                                                                label={
                                                                    option.name
                                                                } // Adjust based on your data structure
                                                                // We're not spreading getTagProps directly
                                                                {...getTagProps(
                                                                    { index }
                                                                )}
                                                            />
                                                        )
                                                    )
                                                }
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        label={t(
                                                            'systemAdmin.systemUsers.location'
                                                        )}
                                                        required
                                                        variant="standard"
                                                    />
                                                )}
                                            />
                                        );
                                    })()}

                                    <TextField
                                        required
                                        id="outlined-required password"
                                        label={t(
                                            'systemAdmin.systemUsers.password'
                                        )}
                                        name="password"
                                        type={
                                            showPassword ? 'text' : 'password'
                                        }
                                        value={newSystemUser.password || ''}
                                        onChange={handleInputChange}
                                        size="small"
                                        variant="standard"
                                        helperText={t(
                                            'systemAdmin.systemUsers.passwordHelp'
                                        )}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Tooltip
                                                        title={t(
                                                            'systemAdmin.systemUsers.generatePassword'
                                                        )}
                                                        placement="top"
                                                    >
                                                        <IconButton
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                generatePassword();
                                                            }}
                                                            size="small"
                                                            edge="end"
                                                        >
                                                            <AutorenewIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip
                                                        title={t(
                                                            'systemAdmin.systemUsers.showHidePassword'
                                                        )}
                                                        placement="top"
                                                    >
                                                        <IconButton
                                                            onClick={
                                                                handleClickShowPassword
                                                            }
                                                            size="small"
                                                            edge="end"
                                                        >
                                                            {showPassword ? (
                                                                <VisibilityOff />
                                                            ) : (
                                                                <Visibility />
                                                            )}
                                                        </IconButton>
                                                    </Tooltip>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <Grid
                                        item
                                        sm={5}
                                        style={{ marginLeft: '3%' }}
                                    >
                                        <Slider
                                            value={
                                                passwordStrength
                                                    ? passwordStrength.score
                                                    : 0
                                            }
                                            max={4}
                                            step={null}
                                            marks={marks}
                                            style={{
                                                color: getPasswordStrengthColor(
                                                    passwordStrength
                                                        ? passwordStrength.score
                                                        : 0
                                                ),
                                            }}
                                            track={false}
                                        />
                                    </Grid>
                                    {(() => {
                                        if (edit) {
                                            return (
                                                <Button
                                                    onClick={editSystemUser}
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    {t(
                                                        'systemAdmin.systemUsers.edit'
                                                    )}
                                                </Button>
                                            );
                                        }
                                        return (
                                            <Button
                                                onClick={saveSystemUser}
                                                variant="contained"
                                                color="primary"
                                                disabled={
                                                    passwordStrength
                                                        ? passwordStrength.score <
                                                          2
                                                        : true
                                                }
                                            >
                                                {t(
                                                    'systemAdmin.systemUsers.add'
                                                )}
                                            </Button>
                                        );
                                    })()}
                                </form>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
            </main>
        </div>
    );
};

export default SystemUsers;
